import React from 'react';
import PropTypes from 'prop-types';

import PercentageFormatter from './PercentageFormatter.react';

// Refactoring to use forwardRef to properly handle MUI refs
const PercentageInputFormatter = React.forwardRef<any, any>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <PercentageFormatter
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
});

PercentageInputFormatter.propTypes = {
  onChange: PropTypes.func.isRequired,
};

PercentageInputFormatter.displayName = 'PercentageInputFormatter';

export default PercentageInputFormatter;
